import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {TransferredEvent$key} from './__generated__/TransferredEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type TransferredEventProps = {
  queryRef: TransferredEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function TransferredEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: TransferredEventProps): JSX.Element {
  const {actor, createdAt, fromRepository, databaseId} = useFragment(
    graphql`
      fragment TransferredEvent on TransferredEvent {
        databaseId
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        createdAt
        fromRepository {
          nameWithOwner
          url
        }
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
    >
      <>
        {LABELS.timeline.transferredThis}
        <Link href={`${fromRepository?.url}`} sx={{color: 'fg.default', ml: 1, mr: 1}} muted>
          {fromRepository?.nameWithOwner}
        </Link>
      </>
    </TimelineRow>
  )
}

try{ TransferredEvent.displayName ||= 'TransferredEvent' } catch {}